export interface TenantCreationRequestModel {
    tenantName: string;
    adminEmail: string;
    adminPassword: string;
    ownerEmail: string;
}
